export default __webpack_public_path__ + "static/media/2.3493c5f9.png";